import { render } from "./InformationDocumentCreate.vue?vue&type=template&id=df6e268e&ts=true"
import script from "./InformationDocumentCreate.vue?vue&type=script&lang=ts"
export * from "./InformationDocumentCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__